import { render } from "./Boletins.vue?vue&type=template&id=2d13da3e"
import script from "./Boletins.vue?vue&type=script&lang=js"
export * from "./Boletins.vue?vue&type=script&lang=js"

import "./Boletins.vue?vue&type=style&index=0&id=2d13da3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__